<template>
  <div v-loading="isLoading">
    <template v-if="!$_.isEmpty(notes)">
      <p v-if="isShowOnlyOne">
        {{ $_.get(notes[0], 'content', '-') }}
        <el-button
          v-if="notes.length > 1"
          type="text"
          @click.native="() => {
            isShowOnlyOne = false
          }"
        >
          &nbsp;Show More
        </el-button>
      </p>
      <ul v-else>
        <li
          v-for="note in notes"
          :key="note.id"
        >
          {{ $_.get(note, 'content', '-') }}
        </li>
      </ul>
    </template>
    <p
      v-else
      class="text-muted"
    >
      Notes not found
    </p>
  </div>
</template>

<script>
import Event from '@/plugins/sdk/resources/Account/Event'
export default {
  props: {
    event: {
      type: Object,
      required: true,
      validator: function (value) {
        return value instanceof Event
      }
    }
  },
  data () {
    return {
      notes: [],
      isLoading: true,
      isShowOnlyOne: true
    }
  },
  created () {
    this.loadNotes()
  },
  methods: {
    loadNotes () {
      this.isLoading = true
      this.$sdk.note.list(request => {
        request.filters = { resource: `account_event:${this.event.id}` }
        request.order = 'created_at:desc'
      })
        .then(notes => {
          this.notes = notes
        })
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>
